const interfaceGrabs = document.querySelectorAll(".interface--grab");

  interfaceGrabs.forEach((interface_grab) => {
    const interface_grab_first_child = interface_grab.firstElementChild;

    let isDragging = false;
    let startX, startY, scrollLeft, scrollTop;

    const stopDragging = () => {
      isDragging = false;
    };

    interface_grab_first_child.addEventListener("mousedown", (e) => {
      if (e.target.nodeName === "TEXTAREA" || e.target.nodeName === "INPUT") {
        return; // Allow text selection in input/textarea fields
      }
      e.preventDefault(); // Prevent native text drag
      isDragging = true;
      startX = e.pageX - interface_grab.offsetLeft;
      startY = e.pageY - interface_grab.offsetTop;
      scrollLeft = interface_grab.scrollLeft;
      scrollTop = interface_grab.scrollTop;
    });

    interface_grab_first_child.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - interface_grab.offsetLeft;
      const y = e.pageY - interface_grab.offsetTop;
      const walkX = (x - startX) * 2; // Adjust sensitivity as needed
      const walkY = (y - startY) * 2;
      interface_grab.scrollLeft = scrollLeft - walkX;
      interface_grab.scrollTop = scrollTop - walkY;
    });

    document.addEventListener("mouseup", stopDragging);
    interface_grab_first_child.addEventListener("mouseleave", stopDragging);

    // Prevent text selection during drag
    interface_grab_first_child.addEventListener("selectstart", (e) => {
      if (isDragging) e.preventDefault();
    });
  });

function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function drawGradientAtPoint(x, y) {
    const gradientRadius = 75; // Radius of the gradient effect
    const gradient = ctx.createRadialGradient(x, y, 0, x, y, gradientRadius);

    // Define the gradient stops
    gradient.addColorStop(0, "rgba(255, 255, 255, 0.5)"); // White at the center
    gradient.addColorStop(1, "rgba(255, 255, 255, 0)"); // Transparent at the edge

    // Save current state
    ctx.save();

    // Set composite operation for blending
    ctx.globalCompositeOperation = "lighter"; // Creates a glowing effect
    ctx.fillStyle = gradient;
    ctx.beginPath();
    ctx.arc(x, y, gradientRadius, 0, Math.PI * 2, false);
    ctx.fill();

    // Restore previous state
    ctx.restore();
  }

  const canvas = document.getElementById("colorfulCanvas");
  const ctx = canvas.getContext("2d");

  function resizeCanvas() {
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width;
    canvas.height = rect.height;
  }

  let circles = [];
  const radiusMax = 40;
  const radiusMin = 10;
  const density = 0.0003;
  let resizeTimeout;
  let animationId;
  const speedMax = 0.25;
  const speedMin = 0.01;

  let mouse = { x: null, y: null, isHovering: false };
  let activeTouches = []; // Track active touch points

  class Circle {
    constructor(x, y, speed, angle, radius, a, da, hue) {
      this.x = x;
      this.y = y;
      this.radius = radius;
      this.speed = speed;
      this.angle = angle;
      this.dx = Math.cos(this.angle) * this.speed;
      this.dy = Math.sin(this.angle) * this.speed;
      this.hue = hue;
      this.a = a;
      this.da = da;
    }

    draw() {
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false);
      ctx.fillStyle = `hsla(${this.hue}, 70%, 60%, ${this.a * 0.625 + 0.05})`;
      ctx.fill();
    }

    update(deltaTime) {
      const speedFactor = deltaTime / 16.67;

      // Combine mouse and touch points into a single array
      const interactionPoints = [];

      // Add mouse point if hovering
      if (mouse.isHovering) {
        interactionPoints.push({ x: mouse.x, y: mouse.y });
      }

      // Add active touch points
      interactionPoints.push(...activeTouches);

      // Loop through interaction points to calculate influence
      interactionPoints.forEach(point => {
        const dx = point.x - this.x;
        const dy = point.y - this.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        if (distance < this.radius * 2) {
          this.dx -= dx / distance;
          this.dy -= dy / distance;
          this.speed += (2 * radiusMax - distance) * 0.01; // Stronger force scaling
          this.angle = Math.atan2(this.dy, this.dx);
        }
      });

      // Occasionally adjust speed for variability
      if (Math.random() < 0.5) { // chance per frame
        const speedChange = (Math.random() - 0.5) * (speedMax - speedMin) * speedFactor * 0.1; // Small speed adjustment
        this.speed = Math.min(Math.max(this.speed + speedChange, speedMin), speedMax * 10); // Clamp between speedMin and speedMax
      }

      // Occasionally adjust angle for variability
      if (Math.random() < 0.5) { // chance per frame
        const angleChange = (Math.random() - 0.5) * Math.PI * 0.0125; // Small angle adjustment
        this.angle += angleChange;
      }

      // Bounce off edges and reposition just outside bounds
      let bounced = false;

      if (this.x + this.radius < -1) { // Left edge
        this.x = -1 * this.radius; // Reposition just outside the left boundary
        this.angle = Math.PI - this.angle; // Reflect angle horizontally
        bounced = true;
      } else if (this.x - this.radius > canvas.width + 1) { // Right edge
        this.x = canvas.width + this.radius; // Reposition just outside the right boundary
        this.angle = Math.PI - this.angle; // Reflect angle horizontally
        bounced = true;
      }

      if (this.y + this.radius < -1) { // Top edge
        this.y = -1 * this.radius; // Reposition just outside the top boundary
        this.angle = -this.angle; // Reflect angle vertically
        bounced = true;
      } else if (this.y - this.radius > canvas.height + 1) { // Bottom edge
        this.y = canvas.height + this.radius; // Reposition just outside the bottom boundary
        this.angle = -this.angle; // Reflect angle vertically
        bounced = true;
      }

      if (bounced) {
        this.speed *= 1.2; // Reduce speed slightly
      }

      if (this.speed > speedMax) {
        // Apply drag (linear)
        const dragCoefficient = 0.99; // Lower values mean stronger drag
        this.speed *= Math.pow(dragCoefficient, speedFactor);

        // Apply drag (optional quadratic drag for high speeds)
        // const dragCoefficient = 0.001; // Customize based on desired effect
        // this.speed -= dragCoefficient * Math.pow(this.speed, 2) * speedFactor;
        // this.speed = Math.max(this.speed, 0); // Prevent negative speed
      }

      const speedPercent = (this.speed - speedMin) / (speedMax - speedMin);

      // Update position
      this.x += Math.cos(this.angle) * this.speed * speedFactor;
      this.y += Math.sin(this.angle) * this.speed * speedFactor;

      // Gradually shift hue
      this.hue += lerp(0.5, 0.7, speedPercent) * speedFactor;
      if (this.hue > 360) this.hue = 0;

      // Pulse alpha
      this.a += this.da * lerp(0, 0.2, speedPercent) * speedFactor;
      if (this.a >= 1 || this.a <= 0) {
        this.da = -this.da;
      }

      // Occasionally reverse Pulse alpha
      if (Math.random() < 0.01) { // chance per frame
        this.da = -this.da;
      }

      this.draw();
    }
  }

  function createCircles() {
    circles = [];
    const canvasArea = canvas.width * canvas.height;
    const numCircles = Math.ceil(canvasArea * density);

    for (let i = 0; i < numCircles; i++) {
      const radius = Math.random() * (radiusMax - radiusMin) + radiusMin;
      const x = Math.random() * (canvas.width + radius * 2) - radius;
      const y = Math.random() * (canvas.height + radius * 2) - radius;
      const speed = Math.random() * (speedMax - speedMin) + speedMin;
      const angle = Math.random() * Math.PI * 2;
      const a = Math.random();
      const da = (Math.random() > 0.5 ? 1 : -1) * 0.005;
      const hue = Math.random() * 360;

      circles.push(new Circle(x, y, speed, angle, radius, a, da, hue));
    }
  }

  let lastTime = 0;

  function animate(currentTime) {
    animationId = requestAnimationFrame(animate);

    const deltaTime = currentTime - lastTime;
    lastTime = currentTime;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    circles.forEach(circle => circle.update(deltaTime));

    // Draw gradient effects at interaction points
    if (mouse.isHovering) {
        drawGradientAtPoint(mouse.x, mouse.y);
    }

    activeTouches.forEach(touch => {
        drawGradientAtPoint(touch.x, touch.y);
    });
  }

  function startAnimation() {
    lastTime = performance.now();
    animationId = requestAnimationFrame(animate);
  }

  function stopAnimation() {
    cancelAnimationFrame(animationId);
  }

  function initCanvas() {
    if (!canvas || !ctx) {
      console.error("Canvas or context not found!");
      return;
    }

    resizeCanvas();
    createCircles();
    startAnimation();

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const rect = canvas.getBoundingClientRect();
        if (canvas.width !== rect.width || canvas.height !== rect.height) {
          resizeCanvas();
          createCircles();
        }
      }, 500);
    });

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        stopAnimation();
      } else {
        startAnimation();
      }
    });

    canvas.addEventListener("mousemove", event => {
      const rect = canvas.getBoundingClientRect();
      mouse.x = event.clientX - rect.left;
      mouse.y = event.clientY - rect.top;
      mouse.isHovering = true;
    });

    canvas.addEventListener("mouseleave", () => {
      mouse.isHovering = false;
    });

    // Handle touch events
    canvas.addEventListener("touchstart", event => {
      event.preventDefault();
      activeTouches = Array.from(event.touches).map(touch => ({
        x: touch.clientX - canvas.getBoundingClientRect().left,
        y: touch.clientY - canvas.getBoundingClientRect().top,
      }));
    });

    canvas.addEventListener("touchmove", event => {
      event.preventDefault();
      activeTouches = Array.from(event.touches).map(touch => ({
        x: touch.clientX - canvas.getBoundingClientRect().left,
        y: touch.clientY - canvas.getBoundingClientRect().top,
      }));
    });

    canvas.addEventListener("touchend", event => {
      activeTouches = Array.from(event.touches).map(touch => ({
        x: touch.clientX - canvas.getBoundingClientRect().left,
        y: touch.clientY - canvas.getBoundingClientRect().top,
      }));
    });

    canvas.addEventListener("touchcancel", () => {
      activeTouches = [];
    });
  }

  initCanvas();

document.addEventListener('DOMContentLoaded', () => {
  // Function to validate inputs
  const validateInput = (input) => {
    const value = input.value.trim();
    const type = input.type;

    // Regular expressions for validation
    const patterns = {
      text: /^[a-zA-Z0-9\s]*$/, // Allow letters, numbers, and spaces
      password: /^.{6,}$/, // At least 6 characters
      url: /^(https?:\/\/)?[\w-]+(\.[\w-]+)+[/#?]?.*$/, // Basic URL pattern
      email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, // Email pattern
      tel: /^\(\d{3}\) \d{3}-\d{4}$/, // U.S. phone number format (999) 999-9999
      search: /^.+$/, // Any non-empty value
      number: /^-?\d+$/, // Only numbers
      file: /.+/ // Any non-empty file value
    };

    // Validate based on type
    if (type in patterns) {
      return patterns[type].test(value);
    }

    // If no specific validation, consider valid
    return true;
  };

  // Auto-format phone number input
  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, ''); // Remove non-numeric characters
    const match = digits.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (!match) return value;

    const [, area, prefix, line] = match;
    if (line) return `(${area}) ${prefix}-${line}`;
    if (prefix) return `(${area}) ${prefix}`;
    if (area) return `(${area}`;
    return '';
  };

  // Add event listeners to inputs
  const inputs = document.querySelectorAll('#forms__input input');
  inputs.forEach((input) => {
    input.addEventListener('input', (event) => {
      // Remove existing classes
      input.classList.remove('valid', 'invalid');

      // Skip validation for disabled inputs
      if (input.disabled) return;

      // Auto-format phone number
      if (input.type === 'tel') {
        const formatted = formatPhoneNumber(input.value);
        input.value = formatted;
      }

      // If input is empty, do not add any class
      if (input.value.trim() === '') {
        return;
      }

      // Add class based on validation result
      if (validateInput(input)) {
        input.classList.add('valid');
      } else {
        input.classList.add('invalid');
      }
    });
  });
});

